const ALERT_SHOW = 'alerts/ALERT_SHOW';
const ALERT_DISMISS = 'alerts/ALERT_DISMISS';

export default {
  ALERT_SHOW,
  ALERT_DISMISS,
};
